import { Component }        from '@angular/core';
import { Router,
         NavigationExtras } from '@angular/router';
import { AuthService }      from './auth.service';
import { Observable } from 'rxjs/Observable';
import { AuthData } from 'app/core/data/auth-data';

@Component({
  template: `
    <h3>LOGOUT</h3>
    <p *ngIf="(userData | async)">Vous êtes toujours connecté</p>
    <p *ngIf="!(userData | async)">Vous avez été deconnecté</p>`
})
export class LogoutComponent {
  message: string;
  public userData:Observable<AuthData>=null;

  constructor(public authService: AuthService, public router: Router) {
    this.userData = authService.emitter;
    this.logout();
  }

  logout() {
    this.authService.logout();
  }
}


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/randonneurs-2018-build-and-to-local/src/app/core/security/logout.component.ts